"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_browser_1 = require("@amplitude/analytics-browser");
const formatter_1 = __importDefault(require("./formatter"));
class Tracker {
    constructor(apiKey, userId) {
        this.apiKey = apiKey;
        this.userId = "";
        try {
            if (userId !== null && userId !== undefined && userId != "") {
                (0, analytics_browser_1.init)(apiKey, userId);
            }
            else {
                (0, analytics_browser_1.init)(apiKey);
            }
            this.initialised = true;
        }
        catch (e) {
            if (typeof e === 'string') {
                console.log(e);
            }
            else if (e instanceof Error) {
                console.log(e.message);
            }
            this.initialised = false;
        }
        this.formatter = new formatter_1.default();
        this.amplitudeIdentify = new analytics_browser_1.Identify();
    }
    trackEvent(eventName, eventProps) {
        if (!this.initialised) {
            return;
        }
        try {
            if (typeof eventProps != "undefined" && eventProps != null) {
                (0, analytics_browser_1.track)(eventName, eventProps);
                return;
            }
            (0, analytics_browser_1.track)(eventName);
        }
        catch (e) {
            console.log(e);
        }
    }
    getBaseProperties() {
        let currentLocation = "";
        if (typeof window.location !== "undefined") {
            currentLocation = window.location.href;
        }
        return {
            "referrer-url": document.referrer,
            "location-url": currentLocation,
        };
    }
    trackSignupPageViewed(signupFlowPath) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), { "signup-flow-path": signupFlowPath });
        this.trackEvent("signup-page-viewed", eventProperties);
    }
    trackSignupPlanSelected(signupPlanSelected) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), { "signup-plan-selected": signupPlanSelected });
        this.trackEvent("signup-plan-selected", eventProperties);
    }
    trackSignupSelectPlanPageViewed(planGroupId, planGroupName) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "displayed-plan-group-id": planGroupId,
            "displayed-plan-group-name": planGroupName
        });
        this.trackEvent("signup-select-plan-page-viewed", eventProperties);
    }
    trackCancelButtonClicked() {
        const eventProperties = Object.assign({}, this.getBaseProperties());
        this.trackEvent("cancel-button-clicked", eventProperties);
    }
    trackSignupButtonClicked(signupButtonType) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), { "signup-button-type": signupButtonType });
        this.trackEvent("signup-button-clicked", eventProperties);
    }
    trackSignupSelectPlanButtonClicked(signupPlanSelectedId, signupPlanTypeName, signupPlanPaymentSchedule) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "selected-plan-id": signupPlanSelectedId,
            "selected-plan-type-name": signupPlanTypeName,
            "selected-plan-payment-schedule": signupPlanPaymentSchedule,
        });
        this.trackEvent("signup-select-plan-button-clicked", eventProperties);
    }
    trackUpgradeSelectPlanButtonClicked(selectedPlanId, selectedPlanName, selectedPlanSchedule) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "selected-plan-id": selectedPlanId,
            "selected-plan-type-name": selectedPlanName,
            "selected-plan-payment-schedule": selectedPlanSchedule,
        });
        this.trackEvent("upgrade-select-plan-button-clicked", eventProperties);
    }
    trackUpgradeButtonClicked(buttonType, buttonDetails) {
        let eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "upgrade-button-type": buttonType,
        });
        if (buttonDetails !== null && buttonDetails !== "") {
            eventProperties = Object.assign(Object.assign({}, eventProperties), {
                "upgrade-button-details": buttonDetails,
            });
        }
        this.trackEvent("upgrade-button-clicked", eventProperties);
    }
    trackTrialActivated(buttonType, buttonDetails) {
        let eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "trial-button-type": buttonType,
        });
        if (buttonDetails !== null && buttonDetails !== "") {
            eventProperties = Object.assign(Object.assign({}, eventProperties), {
                "trial-button-details": buttonDetails,
            });
        }
        this.trackEvent("trial-button-clicked", eventProperties);
    }
    trackUpgradePlanSelected(upgradePlanSelected) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "upgrade-plan-selected": upgradePlanSelected,
        });
        this.trackEvent("upgrade-plan-selected", eventProperties);
    }
    trackUpgradePlansPageViewed(upgradePlanGroupId, upgradePlanGroupName) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "displayed-plan-group-id": upgradePlanGroupId,
            "displayed-plan-group-name": upgradePlanGroupName,
        });
        this.trackEvent("upgrade-plans-page-viewed", eventProperties);
    }
    trackUpgradePopupViewed(popupDetails, popupType) {
        const eventProperties = Object.assign(Object.assign({}, this.getBaseProperties()), {
            "upgrade-popup-details": popupDetails,
            "upgrade-popup-type": popupType,
        });
        this.trackEvent("upgrade-popup-viewed", eventProperties);
    }
    setUserProperty(propertyName, propertyValue) {
        this.amplitudeIdentify.setOnce(propertyName, propertyValue);
        (0, analytics_browser_1.identify)(this.amplitudeIdentify);
    }
}
exports.default = Tracker;
